var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"monaco-editor"},[(!_vm.editor)?_c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100","color":"primary"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }